<template>
  <b-row>
    <b-col cols="12">
      <support-category-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import SupportCategoryAddForm from './SupportCategoryAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    SupportCategoryAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
